import React from 'react';
import BackIcon from '../../common/Back/BackIcon';
import PageHeading from '../../common/Heading/PageHeading';
import { FormContentTitle, FormHeading } from '../../ui/styled';
import Grid from '@mui/material/Grid';
import { useDispatch } from 'react-redux';
import OrganizationField from './OrganizationPage/OrganizationField/OrganizationField';
import OrganizationCheckBox from './OrganizationPage/OrganizationCheckBox/OrganizationCheckBox';
import FormInputText from '../../common/Forms/FormTextField';
import { setOrgKey } from '../../../redux/organization/organizationForm/organizationFormSlice';

const OrganizationForm = (props) => {
  const { control, defaultValue, register, errors } = props;
  const dispatch = useDispatch();

  const getHeading = () => {
    return (
      <FormHeading container>
        <FormContentTitle item xs={12} sm={2.5}>
          <BackIcon />
          <PageHeading title='Organization Detail' />
        </FormContentTitle>
        <Grid item xs={12} sm={9.5}>
          <FormInputText
            name='orgKey'
            type='text'
            control={control}
            errors={!!errors.orgKey}
            helperText={errors?.orgKey?.message}
            label='Organization Key'
            register={register('orgKey', {
              onChange: (e) => dispatch(setOrgKey(e.target.value)),
            })}
          />
        </Grid>
      </FormHeading>
    );
  };

  return (
    <>
      {getHeading()}
      <>
        <OrganizationField
          control={control}
          defaultValue={defaultValue}
          register={register}
          errors={errors}
        />
        <OrganizationCheckBox
          control={control}
          defaultValue={defaultValue}
          register={register}
        />
      </>
    </>
  );
};

export default OrganizationForm;
